<template>
  <div id="app" v-if="!loading">
    <alert-container />
    <loader-container />
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import Axios from 'axios';
import AlertContainer from 'components/Alert/AlertContainer';
import LoaderContainer from 'components/Loader/LoaderContainer';
import { mapMutations } from 'vuex';

export default {
  name: 'App',
  components: {
    AlertContainer,
    LoaderContainer,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    layout() {
      return `${this.$route.meta.layout || 'default'}-layout`;
    },
  },
  methods: {
    ...mapMutations([
      'setUserPermissions',
    ]),
  },
  beforeCreate() {
    Axios.get('/admin/users/current')
      .then(({ data: { permissions } }) => {
        this.setUserPermissions(permissions);
        if (this.$router.currentRoute.name === 'login') {
          this.$router.replace({ name: 'students' });
        }
      })
      .catch(() => {
        this.setUserPermissions({});
        this.$router.replace({ name: 'login' }).catch(e => e);
      })
      .finally(() => { this.loading = false; });
  },
};
</script>
